<script setup lang="ts">
const { article } = defineProps<{
  article: CrystallizeArticle
}>()

provide(diKeys.article, computed(() => article))
</script>

<template>
  <div class="grid grid-rows-subgrid row-span-full">
    <NettbutikkArticleTitle :text="article?.components.title" class="title-xl" />
    <NettbutikkArticleBody
      class="text-primary overflow-hidden"
      :header-image="article?.components?.headerImage"
      :layout="{
        regular: 'col-span-full lg:col-start-2 lg:-col-end-2',
      }"
    />
  </div>
</template>
